/**
 * The super-admin dashboard.
 *
 * Two sections stacked vertically: pending account requests at the
 * top (the thing that usually needs the admin's attention), all
 * users below (reference + direct status management).
 *
 * CLAUDE.md §Admin UI allows denser layouts here — no wallet-card
 * warmth, no hero treatment. Just a clear, utilitarian page using
 * the same warm-light palette as the rest of the app.
 */

import { PendingRequestsSection } from "@/features/admin/PendingRequestsSection";
import { UsersSection } from "@/features/admin/UsersSection";

export function AdminDashboardPage() {
  return (
    <main className="max-w-[1040px] mx-auto px-6 md:px-11 pt-16 pb-24 flex flex-col gap-12">
      <div className="flex flex-col gap-3">
        <div className="font-sans text-eyebrow uppercase text-coral-deep font-semibold">
          Super admin
        </div>
        <h1 className="font-serif text-display-md text-ink">
          <em className="italic font-normal text-coral-deep">Admin</em> dashboard
        </h1>
        <p className="max-w-[640px] text-[14px] text-ink-muted leading-[1.6]">
          Review pending account requests and manage the user list. Every
          action takes effect on the affected user's next request — no cache
          warmup.
        </p>
      </div>

      <PendingRequestsSection />
      <UsersSection />
    </main>
  );
}
